import React from 'react';
import { about } from '../data/profile';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">About</p>
          <h2>Engineering that ships, then holds up in release.</h2>
        </header>
        <div className="about-layout">
          <div className="prose">
            {about.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          <div className="stat-list">
            {about.stats.map((stat) => (
              <div className="stat" key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
